module.exports = __webpack_public_path__ + "282a508101e9dffdfc1cfd4ffcf559f4.svg";